  <section class="hero" id="hero">
    <div class="shell hero-shell">
      <div class="hero-grid">
        <div class="hero-copy">
          <div class="eyebrow">Ro-Ro planning, rates, and visibility in one place</div>
          <h1>Find better Ro-Ro options faster — and move bookings forward</h1>
          <p>Search routes, compare schedules, monitor port activity, request rates, and track shipments in one platform
            built for deep-sea Ro-Ro logistics.</p>
          <div class="hero-cta">
            <a class="btn btn--primary" data-link="freeTrial" href="javascript:void(0)" (click)="redirect('register')">Start free trial</a>
            <a class="btn btn--secondary" data-link="pricing" href="javascript:void(0)" (click)="redirect('price')">See pricing</a>
          </div>
          <div class="hero-support">Built for shippers, freight forwarders, port operators, and suppliers working with
            deep-sea Ro-Ro and PCTC cargo.</div>
        </div>
        <div class="hero-visual">
          <div class="app-window">
            <div class="app-window__inner">
              <div class="app-topbar">
                <div class="app-tabs">
                  <span class="tab is-active">Route Finder</span>
                  <span class="tab">Schedules</span>
                  <span class="tab">Port Activity</span>
                </div>
                <span class="badge">Live workflow</span>
              </div>
              <div class="app-split">
                <div>
                  <div class="route-list">
                    <div class="route-list__title">Top route options</div>
                    <div class="route-item">
                      <div class="route-item__main">
                        <div>
                          <strong>Bremerhaven → Baltimore</strong>
                          <span>Direct sailing · 19 days</span>
                        </div>
                        <span class="badge">Best fit</span>
                      </div>
                      <small>Carrier match • Price request ready • Schedule confirmed</small>
                    </div>
                    <div class="route-item">
                      <div class="route-item__main">
                        <div>
                          <strong>Antwerp → Jacksonville</strong>
                          <span>1 transshipment · 23 days</span>
                        </div>
                        <span class="badge">Option B</span>
                      </div>
                      <small>Alternate port pair • Commercially viable</small>
                    </div>
                  </div>
                </div>
                <div class="mini-grid">
                  <div class="mini-panel">
                    <div class="mini-panel__title">Operational view</div>
                    <div class="stat-row"><span>Ports monitored</span><strong>62</strong></div>
                    <div class="stat-row"><span>Rate requests today</span><strong>14</strong></div>
                    <div class="stat-row"><span>Tracked shipments</span><strong>37</strong></div>
                  </div>
                  <div class="mini-panel">
                    <div class="mini-panel__title">What teams gain</div>
                    <div class="stat-row"><span>Less manual searching</span><strong>Faster answers</strong></div>
                    <div class="stat-row"><span>More route visibility</span><strong>Better options</strong></div>
                    <div class="stat-row"><span>Smoother follow-up</span><strong>More confidence</strong></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="floating-card floating-card--one"><strong>Why teams choose ENL</strong>
            <p>From first search to shipment follow-up, ENL keeps route, schedule, pricing, and visibility work
              connected.</p>
          </div>
          <div class="floating-card floating-card--two"><strong>Built for commercial speed</strong>
            <p>Answer customers faster, compare sailings more clearly, and move from route search to quotation with less
              friction.</p>
          </div> -->
        </div>
      </div>
    </div>
  </section>
  <main class="main">
    <div class="shell">
      <section class="section" id="proof-and-problem">
        <div class="proof-strip">
          <div class="proof-tile">
            <div class="proof-tile__icon"><svg aria-hidden="true" fill="none" viewbox="0 0 24 24">
                <circle cx="6" cy="18" fill="none" r="2" stroke="currentColor" stroke-linecap="round"
                  stroke-linejoin="round" stroke-width="1.9"></circle>
                <circle cx="18" cy="6" fill="none" r="2" stroke="currentColor" stroke-linecap="round"
                  stroke-linejoin="round" stroke-width="1.9"></circle>
                <path d="M8 17c3-1 5-3 8-9" fill="none" stroke="currentColor" stroke-linecap="round"
                  stroke-linejoin="round" stroke-width="1.9"></path>
                <path d="M16 5h4v4" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                  stroke-width="1.9"></path>
              </svg></div><strong>Search leading global Ro-Ro and PCTC options</strong>
          </div>
          <div class="proof-tile">
            <div class="proof-tile__icon"><svg aria-hidden="true" fill="none" viewbox="0 0 24 24">
                <path d="M7 7h11" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                  stroke-width="1.9"></path>
                <path d="m14 4 4 3-4 3" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                  stroke-width="1.9"></path>
                <path d="M17 17H6" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                  stroke-width="1.9"></path>
                <path d="m10 14-4 3 4 3" fill="none" stroke="currentColor" stroke-linecap="round"
                  stroke-linejoin="round" stroke-width="1.9"></path>
              </svg></div><strong>Compare routes, vessels, ports, and shipping lines</strong>
          </div>
          <div class="proof-tile">
            <div class="proof-tile__icon"><svg aria-hidden="true" fill="none" viewbox="0 0 24 24">
                <rect fill="none" height="14" rx="2" stroke="currentColor" stroke-linecap="round"
                  stroke-linejoin="round" stroke-width="1.9" width="18" x="3" y="5"></rect>
                <path d="m4 7 8 6 8-6" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                  stroke-width="1.9"></path>
              </svg></div><strong>Send rate requests faster and keep deals moving</strong>
          </div>
          <div class="proof-tile">
            <div class="proof-tile__icon"><svg aria-hidden="true" fill="none" viewbox="0 0 24 24">
                <path d="M4 19V5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                  stroke-width="1.9"></path>
                <path d="M4 19h16" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                  stroke-width="1.9"></path>
                <path d="m7 15 4-4 3 3 4-6" fill="none" stroke="currentColor" stroke-linecap="round"
                  stroke-linejoin="round" stroke-width="1.9"></path>
              </svg></div><strong>Expand into tracking and analytics when you need more visibility</strong>
          </div>
        </div>
        <div class="problem-grid">
          <div class="problem-panel">
            <div class="section-kicker">Why teams switch to ENL</div>
            <h2>Stop chasing fragmented schedules and delayed answers</h2>
            <p>Ro-Ro planning is still too manual. Teams jump between PDFs, websites, spreadsheets, emails, and vessel
              updates just to answer simple shipping questions. ENL brings route search, schedule visibility, port
              activity, rate requests, tracking, and analytics together so your team can decide faster and communicate
              with customers more confidently.</p>
          </div>
          <div class="stats-panel">
            <div class="stats-panel__head">What improves</div>
            <div class="stats-list">
              <div class="stat"><strong>Answer customer requests faster</strong>
                <p>Get clearer route and schedule visibility when timing matters.</p>
              </div>
              <div class="stat"><strong>Reduce manual searching</strong>
                <p>Spend less time switching between sources and more time acting.</p>
              </div>
              <div class="stat"><strong>Improve operational visibility</strong>
                <p>Support better planning, follow-up, and communication across the workflow.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="section" id="widget-enl">
        <div class="widget-shell">
        <!-- The ENL widget mounts into this element -->
        <div id="roro-widget"></div>
      </div>
      </section>
      <section class="section" id="modules">
        <div class="section-intro">
          <div class="section-kicker">From first search to shipment follow-up</div>
          <h2>The ENL workflows that keep bookings moving</h2>
          <p>ENL brings route search, schedule visibility, port activity, rate requests, tracking, and analytics
            together in one platform built for deep-sea Ro-Ro logistics.</p>
        </div>
        <div class="module-grid">
          <article class="module-card">
            <div class="module-icon"><svg aria-hidden="true" fill="none" viewbox="0 0 24 24">
                <circle cx="6" cy="18" fill="none" r="2" stroke="currentColor" stroke-linecap="round"
                  stroke-linejoin="round" stroke-width="1.9"></circle>
                <circle cx="18" cy="6" fill="none" r="2" stroke="currentColor" stroke-linecap="round"
                  stroke-linejoin="round" stroke-width="1.9"></circle>
                <path d="M8 17c3-1 5-3 8-9" fill="none" stroke="currentColor" stroke-linecap="round"
                  stroke-linejoin="round" stroke-width="1.9"></path>
                <path d="M16 5h4v4" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                  stroke-width="1.9"></path>
              </svg></div>
            <h3>Route Finder</h3>
            <p><strong>Find better route options faster.</strong> Compare Ro-Ro and PCTC routes between ports, including
              alternatives when no direct sailing exists.</p>
          </article>
          <article class="module-card">
            <div class="module-icon"><svg aria-hidden="true" fill="none" viewbox="0 0 24 24">
                <rect fill="none" height="17" rx="3" stroke="currentColor" stroke-linecap="round"
                  stroke-linejoin="round" stroke-width="1.9" width="18" x="3" y="4"></rect>
                <path d="M8 2v4M16 2v4M3 9h18" fill="none" stroke="currentColor" stroke-linecap="round"
                  stroke-linejoin="round" stroke-width="1.9"></path>
                <path d="M8 13h3M13 13h3M8 17h3" fill="none" stroke="currentColor" stroke-linecap="round"
                  stroke-linejoin="round" stroke-width="1.9"></path>
              </svg></div>
            <h3>Schedule &amp; Port Activity</h3>
            <p><strong>See what is planned — and what is moving.</strong> Monitor schedules, port calls, and vessel
              activity in one workflow instead of checking multiple sources.</p>
          </article>
          <article class="module-card">
            <div class="module-icon"><svg aria-hidden="true" fill="none" viewbox="0 0 24 24">
                <path d="M6 4h9l5 5v9a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z" fill="none" stroke="currentColor"
                  stroke-linecap="round" stroke-linejoin="round" stroke-width="1.9"></path>
                <path d="M15 4v5h5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                  stroke-width="1.9"></path>
                <path d="M8 13h8M8 17h5" fill="none" stroke="currentColor" stroke-linecap="round"
                  stroke-linejoin="round" stroke-width="1.9"></path>
              </svg></div>
            <h3>Rate Requests</h3>
            <p><strong>Move from search to quotation faster.</strong> Turn route and schedule visibility into faster
              rate requests and smoother commercial follow-up.</p>
          </article>
          <article class="module-card">
            <div class="module-icon"><svg aria-hidden="true" fill="none" viewbox="0 0 24 24">
                <path d="M4 19V5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                  stroke-width="1.9"></path>
                <path d="M4 19h16" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                  stroke-width="1.9"></path>
                <path d="m7 15 4-4 3 3 4-6" fill="none" stroke="currentColor" stroke-linecap="round"
                  stroke-linejoin="round" stroke-width="1.9"></path>
                <circle cx="18" cy="8" fill="currentColor" r="1.8" stroke="none"></circle>
              </svg></div>
            <h3>Tracking &amp; Analytics</h3>
            <p><strong>Add more control as operations grow.</strong> Track shipments, improve visibility, and use
              analytics to support better planning and customer communication.</p>
          </article>
        </div>
      </section>
      <section class="section" id="audiences">
        <div class="section-intro">
          <div class="section-kicker">Built for commercial and operational teams</div>
          <h2>Built for the people who keep cargo moving</h2>
          <p>Whether you manage quotations, cargo planning, shipment follow-up, or day-to-day operations, ENL is
            designed to support faster decisions and clearer communication.</p>
        </div>
        <div class="audience-grid">
          <article class="audience-card">
            <div class="audience-icon"><svg aria-hidden="true" fill="none" viewbox="0 0 24 24">
                <path d="m12 3 8 4.5v9L12 21 4 16.5v-9L12 3z" fill="none" stroke="currentColor" stroke-linecap="round"
                  stroke-linejoin="round" stroke-width="1.9"></path>
                <path d="M12 12 20 7.5M12 12 4 7.5M12 12v9" fill="none" stroke="currentColor" stroke-linecap="round"
                  stroke-linejoin="round" stroke-width="1.9"></path>
              </svg></div>
            <h3>Shippers</h3>
            <p>Get faster visibility on route options, schedules, and shipment planning so decisions can move forward
              with less delay.</p>
          </article>
          <article class="audience-card">
            <div class="audience-icon"><svg aria-hidden="true" fill="none" viewbox="0 0 24 24">
                <path d="M7 7h11" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                  stroke-width="1.9"></path>
                <path d="m14 4 4 3-4 3" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                  stroke-width="1.9"></path>
                <path d="M17 17H6" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                  stroke-width="1.9"></path>
                <path d="m10 14-4 3 4 3" fill="none" stroke="currentColor" stroke-linecap="round"
                  stroke-linejoin="round" stroke-width="1.9"></path>
              </svg></div>
            <h3>Freight Forwarders</h3>
            <p>Respond to customer requests faster and compare sailings with more confidence when commercial speed
              matters.</p>
          </article>
          <article class="audience-card">
            <div class="audience-icon"><svg aria-hidden="true" fill="none" viewbox="0 0 24 24">
                <path d="M12 3v11" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                  stroke-width="1.9"></path>
                <circle cx="12" cy="5" fill="none" r="1.6" stroke="currentColor" stroke-linecap="round"
                  stroke-linejoin="round" stroke-width="1.9"></circle>
                <path d="M7 15a5 5 0 0 0 10 0" fill="none" stroke="currentColor" stroke-linecap="round"
                  stroke-linejoin="round" stroke-width="1.9"></path>
                <path d="M8 14H5M19 14h-3" fill="none" stroke="currentColor" stroke-linecap="round"
                  stroke-linejoin="round" stroke-width="1.9"></path>
                <path d="m8 15-2 3M16 15l2 3" fill="none" stroke="currentColor" stroke-linecap="round"
                  stroke-linejoin="round" stroke-width="1.9"></path>
              </svg></div>
            <h3>Port Operators</h3>
            <p>Stay closer to vessel activity and improve planning around port calls with clearer operational
              visibility.</p>
          </article>
          <article class="audience-card">
            <div class="audience-icon"><svg aria-hidden="true" fill="none" viewbox="0 0 24 24">
                <rect fill="none" height="16" rx="2" stroke="currentColor" stroke-linecap="round"
                  stroke-linejoin="round" stroke-width="1.9" width="12" x="6" y="4"></rect>
                <path d="M9 4.5h6a1.5 1.5 0 0 1 1.5 1.5v1h-9V6A1.5 1.5 0 0 1 9 4.5z" fill="none" stroke="currentColor"
                  stroke-linecap="round" stroke-linejoin="round" stroke-width="1.9"></path>
                <path d="M9 11h6M9 15h6" fill="none" stroke="currentColor" stroke-linecap="round"
                  stroke-linejoin="round" stroke-width="1.9"></path>
              </svg></div>
            <h3>Suppliers</h3>
            <p>Support cargo planning and customer communication with clearer route and schedule visibility.</p>
          </article>
        </div>
      </section>
      <section class="section" id="pricing-teaser">
        <div class="pricing-teaser">
          <div class="pricing-teaser__grid">
            <div>
              <div class="section-kicker">Pricing built for Ro-Ro teams</div>
              <h2>Choose the level that fits your workflow</h2>
              <p>Start with a free trial, move to Professional for day-to-day use, or speak with us about Business and
                Enterprise access for multi-user teams, tracking, analytics, and tailored rollout support.</p>
              <div class="pricing-teaser__actions">
                <a class="btn btn--primary" data-link="freeTrial" href="javascript:void(0)" (click)="redirect('register')">Start free trial</a>
                <a class="btn btn--ghost" data-link="pricing" href="javascript:void(0)" (click)="redirect('price')" >See pricing</a>
                <a class="btn btn--ghost" data-link="companyAccess" href="javascript:void(0)" (click)="redirect('')">Request company access</a>
              </div>
            </div>
            <div class="mini-plan-grid">
              <div class="mini-plan"><strong>Free Trial</strong><span>Experience route search, schedules, and core
                  visibility before you commit.</span></div>
              <div class="mini-plan"><strong>Professional</strong><span>For regular users who need route, port, and
                  pricing visibility in one workflow.</span></div>
              <div class="mini-plan"><strong>Business &amp; Enterprise</strong><span>For teams that need shared access,
                  tracking, analytics, and tailored rollout support.</span></div>
            </div>
          </div>
        </div>
      </section>
      <section class="section" id="faq">
        <div class="section-intro">
          <div class="section-kicker">Questions before you get started</div>
          <h2>What buyers usually want to know</h2>
          <p>These are the practical questions teams ask before they start a trial, compare plans, or discuss company
            access.</p>
        </div>
        <div class="faq-grid">
          <article class="faq-item">
            <div class="faq-item__top">
              <h3>Do I need a credit card to get started?</h3><span class="faq-plus">+</span>
            </div>
            <p>Start with the trial flow offered on the site. For company access and tailored setups, contact ENL
              directly.</p>
          </article>
          <article class="faq-item">
            <div class="faq-item__top">
              <h3>Who is ENL Solutions built for?</h3><span class="faq-plus">+</span>
            </div>
            <p>ENL is designed for shippers, freight forwarders, port operators, suppliers, and other teams working with
              deep-sea Ro-Ro logistics.</p>
          </article>
          <article class="faq-item">
            <div class="faq-item__top">
              <h3>Can I get multi-user access?</h3><span class="faq-plus">+</span>
            </div>
            <p>Yes. Team access, annual billing, and tailored commercial terms can be arranged for business customers.
            </p>
          </article>
          <article class="faq-item">
            <div class="faq-item__top">
              <h3>What can I do inside the platform?</h3><span class="faq-plus">+</span>
            </div>
            <p>Depending on your access level, you can search routes, review schedules, monitor port activity, send rate
              requests, track shipments, and use analytics.</p>
          </article>
        </div>
      </section>
      <section class="section" id="final-cta">
        <div class="cta-banner">
          <div class="cta-banner__grid">
            <div>
              <div class="section-kicker" style="color:#9ad0f2; margin-bottom:8px;">Get started</div>
              <h2>Spend less time searching — and more time moving cargo forward</h2>
              <p>See how ENL Solutions helps logistics teams find better options faster, improve visibility, and support
                better shipping decisions.</p>
            </div>
            <div class="cta-banner__actions">
              <a class="btn btn--primary" data-link="freeTrial" href="javascript:void(0)" (click)="redirect('register')">Start free trial</a>
              <a class="btn btn--secondary" data-link="pricing" href="javascript:void(0)" (click)="redirect('price')">See pricing</a>
            </div>
          </div>
        </div>
      </section>
      <!-- <div class="footer">© 2026 ENL Solutions. All rights reserved.</div> -->
    </div>
  </main>
  <div class="mobile-sticky">
    <div>
      <strong>Start exploring ENL</strong>
      <span>Find routes, compare schedules, and move bookings forward.</span>
    </div>
    <a class="btn btn--primary btn--small" data-link="freeTrial" href="javascript:void(0)" (click)="redirect('register')">Start trial</a>
  </div>